// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M0.794189 12.3676L11.9202 23.4937L16.4088 19.0051L5.28306 7.87939L0.794189 12.3676Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.823 17.5909L21.4276 13.9862L18.595 11.1536L21.8695 7.87928L16.4087 2.41846L13.1342 5.69282L10.3016 2.86019L6.69694 6.46485L17.823 17.5909Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-brush-filled')
export default class BrushFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'brush-filled',
    }
  }
}
